import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarListaPrecios() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [nombre, setNombre] = useState('');
    const [codigo, setCodigo] = useState('');
    const [codigoOriginal, setCodigoOriginal] = useState('');
    const [precio, setPrecio] = useState('');
    const [especialidad, setEspecialidad] = useState();

    const [errorlist, setErrorlist] = useState([]);
    
    // Estados RIPS
    const [clasificacionRips, setClasificacionRips] = useState('0');
    const [codigoRips, setCodigoRips] = useState('');
    const [showModalCups, setShowModalCups] = useState(false);
    const [cupsData, setCupsData] = useState([]);
    const [busquedaCups, setBusquedaCups] = useState('');
    const [paginaActualCups, setPaginaActualCups] = useState(1);
    const cupsPorPagina = 10;

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/especialidades-referencia?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/lista-precio',config2)
            .then(response => {
                setNombre(response.data[0].nombre);
                setCodigo(response.data[0].codigo);
                setCodigoOriginal(response.data[0].codigo);
                setPrecio(response.data[0].precio);
                setEspecialidad(response.data[0].clasificacion);
                setClasificacionRips(response.data[0].clasificacionrips || '0');
                setCodigoRips(response.data[0].codigorips || '');
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const cargarCupsData = async () => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    tipo: clasificacionRips
                }
            };
            
            const response = await axios.get('/cups-data', config);
            setCupsData(response.data.Cups || []);
        } catch (error) {
            console.error('Error cargando CUPS:', error);
        }
    };

    const abrirModalCups = () => {
        if (clasificacionRips === '0') {
            alert('Seleccione una categoría RIPS válida');
            return;
        }
        cargarCupsData();
        setShowModalCups(true);
        setBusquedaCups('');
        setPaginaActualCups(1);
    };

    const seleccionarCups = (codigo) => {
        setCodigoRips(codigo);
        setShowModalCups(false);
    };

    const getCupsFiltrados = () => {
        if (!busquedaCups) return cupsData;
        return cupsData.filter(item => 
            item.Codigo.toLowerCase().includes(busquedaCups.toLowerCase()) ||
            item.Nombre.toLowerCase().includes(busquedaCups.toLowerCase())
        );
    };

    const getCupsPaginados = () => {
        const filtrados = getCupsFiltrados();
        const inicio = (paginaActualCups - 1) * cupsPorPagina;
        return filtrados.slice(inicio, inicio + cupsPorPagina);
    };

    const getTotalPaginasCups = () => {
        return Math.ceil(getCupsFiltrados().length / cupsPorPagina);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validación RIPS
        if ((clasificacionRips === '1' || clasificacionRips === '2') && !codigoRips) {
            alert('Debe Seleccionar Un Código CUPS Para La Categoría Seleccionada');
            return;
        }
        
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            uid: userdata.user_id,
            id: id,
            nombre: nombre,
            codigo: codigo,
            codigoOriginal: codigoOriginal,
            precio: precio,
            clasificacion: especialidad,
            clasificacionrips: clasificacionRips,
            codigorips: codigoRips
        };
        
        axios.put('/lista-precio', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El Item De Venta "'+nombre+'" Ha Sido Modificado');
                    history.push('/listas-precios');
                }
            )
            .catch(
                err => {
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-tratamientos">Administrador Contable</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/listas-precios">Listas de Precios</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar Lista de Precios</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Lista de Precios</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="codigo">Referencia</label>
                                                        <input type="text" name="codigo" className="form-control" id="codigo" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.codigo}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre</label>
                                                        <input type="text" name="nombre" className="form-control" id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.nombre}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="precio">Precio</label>
                                                        <input type="text" name="precio" className="form-control" id="precio" value={precio} onChange={(e) => setPrecio(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.precio}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="especialidad">Clasificación</label>
                                                        <select name="especialidad" className="form-control" id="especialidad" value={especialidad} onChange={(e) => setEspecialidad(e.target.value)}>
                                                            <option></option>
                                                            {
                                                                especialidades.map((especialidadReferencia) => 
                                                                    <option value={especialidadReferencia.id}>{especialidadReferencia.nombre}</option>
                                                                )
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.clasificacion}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <hr />
                                            <h5><b>RIPS</b></h5>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="categoriaRips">Categoría</label>
                                                        <select 
                                                            name="categoriaRips" 
                                                            className="form-control" 
                                                            id="categoriaRips" 
                                                            value={clasificacionRips}
                                                            onChange={(e) => {
                                                                setClasificacionRips(e.target.value);
                                                                setCodigoRips('');
                                                            }}
                                                        >
                                                            <option value="0">No aplica</option>
                                                            <option value="1">Consulta</option>
                                                            <option value="2">Procedimiento</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="codigoCups">Código CUPS</label>
                                                        <div className="input-group">
                                                            <input 
                                                                type="text" 
                                                                name="codigoCups" 
                                                                className="form-control" 
                                                                id="codigoCups"
                                                                value={codigoRips}
                                                                readOnly
                                                                placeholder={clasificacionRips === '0' ? 'No aplica' : 'Seleccionar código'}
                                                            />
                                                            {clasificacionRips !== '0' && (
                                                                <div className="input-group-append">
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-info"
                                                                        onClick={abrirModalCups}
                                                                    >
                                                                        <i className="fas fa-search"></i>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-12">
                                                    <div className="d-flex gap-2">
                                                        <Link to="/listas-precios" className="btn btn-secondary">
                                                            Cancelar
                                                        </Link>
                                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                                            Guardar Cambios&nbsp;
                                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                
                {/* Modal CUPS */}
                {showModalCups && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Código CUPS</h5>
                                    <button type="button" className="close" onClick={() => setShowModalCups(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por código o nombre..."
                                            value={busquedaCups}
                                            onChange={(e) => {
                                                setBusquedaCups(e.target.value);
                                                setPaginaActualCups(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Nombre</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getCupsPaginados().map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.Codigo}</td>
                                                        <td>{item.Nombre}</td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarCups(item.Codigo)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Paginación */}
                                    {getTotalPaginasCups() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActualCups === 1}
                                                onClick={() => setPaginaActualCups(paginaActualCups - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActualCups} de {getTotalPaginasCups()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActualCups === getTotalPaginasCups()}
                                                onClick={() => setPaginaActualCups(paginaActualCups + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalCups(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarListaPrecios;